<div class="position-container">
    <select class="select-position" [(ngModel)]="selectedLocation" (change)="saveSelectedPosition()">
    <option value="" disabled selected>{{ 'MAP.POSITION.SELECT' | translate }}</option>
    <option *ngFor="let location of locations" [ngValue]="location">{{ location.name | translate }}</option>
    </select>
    <fa-icon 
        title="{{ 'MAP.POSITION.SAVE_BTN' | translate }}" 
        class="cross-icon" 
        [icon]="faCrosshair" 
        (click)="saveCurrentPosition()"
    ></fa-icon>
</div>